//config file for base url and oauth2 credential
export default {
  baseUrl: "https://bioservice.odoo.com/api/v2",
};

export const APP_VERSION = "0.0.6";
